import customer from "./customer";
import vmCustomerOrder from "./vmCustomerOrder";
import vmOrderDetail from "./vmOrderDetail";

class vmOrderAddEdit {
  customerGUID: string;
  customerObj: customer;
  orderGUID: string;
  orderObj: vmCustomerOrder;
  lstOrderDetail: vmOrderDetail[];

  constructor() {
    this.lstOrderDetail = [];
  }
}

export default vmOrderAddEdit;
